import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ButtonModule, type ButtonPassThrough } from 'primeng/button';
import { DialogService } from 'primeng/dynamicdialog';

import {
  FEATURE_ANNOUNCEMENT_LOAD_STATUS,
  FeatureAnnouncementStoreService,
} from '@customer-portal/data-access/feature-announcements';
import {
  getColor,
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

import { WhatsNewDialogComponent } from '../whats-new-dialog/whats-new-dialog.component';

@Component({
  selector: 'lib-navbar-whats-new',
  imports: [CommonModule, TranslocoDirective, ButtonModule],
  templateUrl: './navbar-whats-new.component.html',
  styleUrl: './navbar-whats-new.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarWhatsNewComponent {
  private readonly announcementStore = inject(FeatureAnnouncementStoreService);
  private readonly dialogService = inject(DialogService);
  private readonly translocoService = inject(TranslocoService);

  readonly buttonPT: ButtonPassThrough = {
    root: {
      style: {
        padding: `${getRem(6.85)} ${getRem(13.71)}`,
        gap: getRem(6),
      },
    },
    label: {
      style: {
        fontWeight: getFontWeight('normal'),
        color: getColor('DarkBlue'),
      },
    },
    icon: {
      style: {
        fontSize: getRem(15),
        color: getColor('DarkBlue'),
      },
    },
  };

  readonly activeFeatures = this.announcementStore.activeFeatures;
  readonly unseenCount = this.announcementStore.unseenCount;
  readonly isAvailable = computed(
    () =>
      this.announcementStore.status() ===
        FEATURE_ANNOUNCEMENT_LOAD_STATUS.READY &&
      this.activeFeatures().length > 0,
  );

  onOpenDialog(): void {
    this.dialogService.open(WhatsNewDialogComponent, {
      header: this.translocoService.translate('whatsNew.title'),
      closable: true,
      modal: true,
      contentStyle: { padding: '0' },
      styleClass: 'whats-new-dialog',
    });
  }
}
